import React from "react";
import Image from "next/image";
import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";

const BannerImage = ({
    src = `${NEXT_IMAGE_CDN}/icon/image_section.png`,
    alt = "Banner Image",
    priority = true,
    className = "",
    width = 2880,
    height = 720,
}) => {
    return (
        <div className={`w-full mx-auto max-w-[1920px] ${className}`}>
            <Image
                src={src}
                alt={alt}
                width={width}
                height={height}
                sizes="100vw"
                priority={priority}
                className="w-full h-auto"
            />
        </div>
    );
};

export default BannerImage;
